export enum ExportTypes {
    MINDEN = 'Minden',
    CSV = 'Csv',
    EXCEL = 'Excel'
}
